import { useContext } from "react";
import AuthContext from "../../../context/auth/AuthContext";
import { haveValue } from "../../../helper/common";
import useTranslator from "../../../hooks/useTranslator";
import PropertyRow from "./PropertyRow";

const PropertyTable = ({
  property,
  onPropertyAward,
  tanentData,
  loadData,
  propId,
  setSearchPropId,
}) => {
  const { _t } = useTranslator();
  const authContext = useContext(AuthContext);
  const { user } = authContext;

  return (
    <>
      <div className="upcoming-box ">
        <table className="upcoming-table landlord-table bigtable_set">
          <thead className="hideOnMobile">
            <tr className="first-row">
              <th style={{ width: "30%" }}> {_t("property")} </th>
              <th> {_t("municipality", "Field in properties table")} </th>
              <th> {_t("postCode", "Field in properties table")} </th>
              <th> {_t("estimatedRent")} </th>
              <th> {_t("linkedTo", "Field in properties table")} </th>
              <th> {_t("sourceId", "Field in properties table")} </th>
              <th> {_t("userName", "Field in properties table")} </th>
              <th> </th>
            </tr>
          </thead>

          <tbody>
            {haveValue(property)
              ? property.map((data) => {
                  return (
                    <PropertyRow
                      data={data}
                      onPropertyAward={onPropertyAward}
                      tanentData={tanentData}
                      loadData={loadData}
                      user={user}
                      propId={propId}
                      setSearchPropId={setSearchPropId}
                      openLinkedPopup={propId === data._id}
                    />
                  );
                })
              : _t("noDetailsFound")}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PropertyTable;
